/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../store';
import ImgPoint from '../../../../../assets/animation_point.gif';
import './animation095.less';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

interface IAnimation095Item {
  title: string;
  content: string;
  tip?: string;
  pic?: string;
}

interface IAnimation095Props {
  items: {
    title?: string;
    tip?: string;
    pic?: string;
    items: IAnimation095Item[];
  }[];
  onCompleted?: () => void;
  className?: string;
}

const Animation095: React.FunctionComponent<IAnimation095Props> = ({
  items,
  onCompleted,
  className,
}) => {
  const { updateParagraphState, language } = useStore();
  const settings =
    language === 'en'
      ? {
          viewlabel: 'Click here',
        }
      : language === 'sc'
      ? {
          viewlabel: '点击查看',
        }
      : {
          viewlabel: '點擊查看',
        };
  const [tabValue, setTabValue] = useState('1');
  const [completed, setCompleted] = useState(items.map((itm) => 0));
  const [lastClick, setLastClick] = useState(0);

  const play = (index: number) => {
    setCompleted(
      completed.map((itm: any, idx: number) => (idx === index ? itm + 1 : itm))
    );
    setLastClick(lastClick + 1 < 4 ? lastClick + 1 : lastClick);
  };

  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!completed.some((itm, idx) => itm + 1 < items[idx].items.length)) {
      onCompleted && onCompleted();
    }
  }, [completed]);

  useEffect(() => {
    if (tabValue === '1') {
      if (lastClick < 3) {
        setShow(false);
      } else {
        setShow(true);
      }
    } else {
      setShow(false);
    }
  }, [tabValue, lastClick]);
  return (
    <div className={`animation095 ${className || ''}`}>
      <img className="click-point1" hidden={!show} src={ImgPoint} alt="" />
      <Tabs
        type="card"
        className={`animation095-topic-tab tab${tabValue}`}
        onChange={(activeKey) => setTabValue(activeKey)}
      >
        {items.map((itm: any, index: number) => (
          <TabPane tab={itm.title} key={`${index + 1}`}>
            <div className="animation095-component003">
              {itm.tip && (
                <>
                  <div className="component003-tip">
                    <span
                      className="tip-text"
                      dangerouslySetInnerHTML={{ __html: itm.tip }}
                    />
                    <div className="tip-arrow">
                      <div className="line1" />
                      <div className="line2" />
                    </div>
                  </div>
                  <img
                    src={require(`../../../../../assets/${itm.pic}`).default}
                    alt=""
                  />
                </>
              )}
              {itm.items[lastClick]?.tip && (
                <>
                  <div className="component003-tip">
                    <span
                      className="tip-text"
                      dangerouslySetInnerHTML={{
                        __html: itm.items[lastClick]?.tip,
                      }}
                    />
                    <div className="tip-arrow">
                      <div className="line1" />
                      <div className="line2" />
                    </div>
                  </div>
                  <img
                    src={
                      require(`../../../../../assets/${itm.items[lastClick]?.pic}`)
                        .default
                    }
                    alt=""
                  />
                </>
              )}
            </div>
            <div className="animation095-card-tab">
              <div className="animation095-card-list">
                {itm.items.map((card: IAnimation095Item, idx: number) => (
                  <div
                    key={idx}
                    className="animation095-card-item"
                    style={{ width: `${(1 / itm.items.length) * 100}%` }}
                  >
                    <div className="animation095-card-item-title en-line-height-21">
                      <div dangerouslySetInnerHTML={{ __html: card.title }} />
                    </div>
                    <div className="animation095-card-item-content en-line-height-21">
                      <div
                        className="text"
                        dangerouslySetInnerHTML={{ __html: card.content }}
                      />
                    </div>
                    {completed[index] < idx && (
                      <div className="clickable" onClick={() => play(index)}>
                        <div className="clickable-label">
                          {settings.viewlabel}
                        </div>
                        {completed[index] === idx - 1 && (
                          <img className="click-point" src={ImgPoint} alt="" />
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default Animation095;
